import type {
  PhotoGalleryDTO,
  VideoGalleryDTO,
} from '~/shared/api/client/galleries/galleries.dto';
import { getMonthName } from '~/shared/utils/formatDate';

type GalleryItem = PhotoGalleryDTO | VideoGalleryDTO;

export function getGalleryCover(item: GalleryItem): string | null {
  const cover = 'cover_photo' in item ? item.cover_photo : item.cover_video;
  return cover?.file_url ?? null;
}

export function formatGalleryDate(item: GalleryItem): string | null {
  const dateValue = item.publication_date ?? item.creation_datetime;
  if (!dateValue) {
    return null;
  }

  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) {
    return null;
  }

  const day = String(date.getDate()).padStart(2, '0');
  return `${day} ${getMonthName(date.getMonth(), 'genitive')} ${date.getFullYear()}`;
}
